import Button from './components/Button';
import './index.css';

function App() {
  const handleClick = () => {
    alert('Button clicked from Remote App 1!');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">
            Remote App 1
          </h1>
          <p className="text-lg text-gray-600 mb-6">
            Micro-frontend using Module Federation with Rspack
          </p>

          <div className="border-t border-gray-200 pt-6">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Features
            </h2>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <span className="inline-block w-6 h-6 bg-green-500 rounded-full mr-3 flex-shrink-0 flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span className="text-gray-700">
                  <strong>React 18.3.1</strong> - Singleton shared dependency
                </span>
              </li>
              <li className="flex items-start">
                <span className="inline-block w-6 h-6 bg-green-500 rounded-full mr-3 flex-shrink-0 flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span className="text-gray-700">
                  <strong>Module Federation</strong> - Exposes ./App and ./Button
                </span>
              </li>
              <li className="flex items-start">
                <span className="inline-block w-6 h-6 bg-green-500 rounded-full mr-3 flex-shrink-0 flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span className="text-gray-700">
                  <strong>Tailwind CSS</strong> - With shadcn/ui components
                </span>
              </li>
              <li className="flex items-start">
                <span className="inline-block w-6 h-6 bg-green-500 rounded-full mr-3 flex-shrink-0 flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </span>
                <span className="text-gray-700">
                  <strong>TypeScript</strong> - Strict mode enabled
                </span>
              </li>
            </ul>

            <div className="bg-gray-50 rounded-lg p-6 mb-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Demo Component
              </h3>
              <p className="text-gray-600 mb-4">
                This button component is exported via Module Federation and can be consumed by the host application:
              </p>
              <Button onClick={handleClick}>
                Click Me - I'm from Remote 1!
              </Button>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="text-sm text-blue-800">
                <strong>Running on:</strong> http://localhost:3001
              </p>
              <p className="text-sm text-blue-800 mt-1">
                <strong>Remote Entry:yaay</strong> http://localhost:3001/remoteEntry.js
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
